import { render, staticRenderFns } from "./SimpleBannerCard.vue?vue&type=template&id=7e0e24bc&"
import script from "./SimpleBannerCard.vue?vue&type=script&lang=ts&"
export * from "./SimpleBannerCard.vue?vue&type=script&lang=ts&"
import style0 from "./SimpleBannerCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VFlex,VLayout})
